import {type List, type OrderedSet, type Set} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type Plan} from 'web-app/react/entities/plans/model';
import {type BulkChangePreviewData} from 'web-app/react/institution/settings/manage-plans/schedule-change/schedule-change-form/schedule-change-form';

import {type PlanPreviewStates, type Sorting} from './types';

const domain = 'MANAGE_PLANS';

export const {action: changeChildrenToShow} = createAction(
    `${domain}/CHANGE_CHILDREN_TO_SHOW`,
    (childrenToShow: string) => ({childrenToShow}),
);

export const {action: selectChild} = createAction(`${domain}/SELECT_CHILD`, (childId: string, select: boolean) => ({
    childId,
    select,
}));

export const {action: selectChildForChange} = createAction(
    `${domain}/SELECT_CHILD_FOR_CHANGE`,
    (childId: string, select: boolean) => ({childId, select}),
);

export const {action: toggleScheduleChange} = createAction(`${domain}/TOGGLE_SCHEDULE_CHANGE`, (show: boolean) => ({
    show,
}));

export const {
    action: doPlanPreview,
    success: doPlanPreviewSuccess,
    failed: doPlanPreviewFailed,
    aborted: doPlanPreviewAborted,
} = createAction(
    `${domain}/DO_PLAN_PREVIEW`,
    (institutionId: string, childIds: Set<string>, formData: BulkChangePreviewData) => ({
        institutionId,
        childIds,
        formData,
    }),
    (childId: string, childPreviewStates: PlanPreviewStates) => ({childId, childPreviewStates}),
    (e: any, childId: string) => ({e, childId}),
    (childId: string) => ({childId}),
);

export const {action: fixPlan} = createAction(`${domain}/FIX_PLAN`, (plan: Plan) => ({plan}));

export const {action: sessionsAndProductsFetched} = createAction(
    `${domain}/SESSIONS_AND_PRODUCTS_FETCHED`,
    (childIds: Set<string>, formData: BulkChangePreviewData) => ({childIds, formData}),
);

export const {action: selectAllChildren} = createAction(
    `${domain}/SELECT_ALL_CHILDREN`,
    (childIds: OrderedSet<string> | null) => ({childIds}),
);

export const {action: stepChanged} = createAction(`${domain}/STEP_CHANGED`, (step: number) => ({step}));

export const {action: changeGroup} = createAction(`${domain}/CHANGE_GROUP`, (groupId: string) => ({groupId}));

export const {action: changeHighlightBy} = createAction(`${domain}/HIGHLIGHT`, (highlightBy: string) => ({
    highlightBy,
}));

export const {action: showing} = createAction(`${domain}/SHOWING`, (showing: boolean) => ({showing}));

export const {action: showExpiredPlans} = createAction(`${domain}/SHOW_EXPIRED_PLANS`, (showExpiredPlans: boolean) => ({
    showExpiredPlans,
}));

export const {
    action: fetchPlans,
    success: fetchPlansSuccess,
    failed: fetchPlansFailed,
} = createAction(
    `${domain}/FETCH_PLANS`,
    (institutionId: string, showExpiredPlans: boolean, childIds: Set<string>) => ({
        institutionId,
        showExpiredPlans,
        childIds,
    }),
    (allPlansFetched: boolean) => ({allPlansFetched}),
);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, (institutionId: string) => ({institutionId}));

export const {
    action: fetchChildrenAndPlans,
    success: fetchChildrenAndPlansSuccess,
    failed: fetchChildrenAndPlansFailed,
} = createAction(
    `${domain}/FETCH_CHILDREN_AND_PLANS`,
    (
        institutionId: string,
        includeCurrent: boolean,
        includeFuture: boolean,
        includePast: boolean,
        showExpiredPlans: boolean,
    ) => ({institutionId, includeCurrent, includeFuture, includePast, showExpiredPlans}),
    (allPlansFetched: boolean, children: List<any>) => ({allPlansFetched, children}),
);

export const {action: schedulePlanChangeForSelectedChildren} = createAction(
    `${domain}/SCHEDULE_PLAN_CHANGE_FOR_SELECTED_CHILDREN`,
    () => ({}),
);

export const {
    action: deletePlansForSelectedChildren,
    success: deletePlansForSelectedChildrenSuccess,
    failed: deletePlansForSelectedChildrenFailed,
} = createAction(
    `${domain}/DELETE_PLANS_FOR_SELECTED_CHILDREN`,
    () => ({}),
    (plan: Plan) => ({plan}),
    (e: any, plan: Plan) => ({e, plan}),
);

export const {
    action: schedulePlanChangeForChild,
    success: schedulePlanChangeForChildSuccess,
    failed: schedulePlanChangeForChildFailed,
} = createAction(
    `${domain}/SCHEDULE_PLAN_CHANGE_FOR_SELECTED_CHILD`,
    () => ({}),
    (childId: string, previewPlan: Plan) => ({childId, previewPlan}),
    (e: any, childId: string, previewPlan: Plan) => ({e, childId, previewPlan}),
);

export const {action: sortChildren} = createAction(`${domain}/SORT_CHILDREN`, (sorting: Sorting) => ({
    sorting,
}));

export const {action: resetSelectedChildren} = createAction(`${domain}/RESET_SELECTED_CHILDREN`, () => ({}));
